export class NumberCurrencyData {
    name: string;
    placeholder: string;
    amount: number;
    currency: string;
    currencyName: string;
}
